module.exports = __webpack_public_path__ + "img/palma-restaurant.ef7f9dc1.jpg";